<template>
    <div class="page">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/offers.png" />
        </header>

        <div class="scroller2 green">
            <header>
                <h2>Create offer</h2>
                <ul class="links">
                    <li>
                        <a
                            class="cancel"
                            @click.prevent="goToLocation({ name: 'proOffers' })"
                            href="#"
                        >
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <partials />
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import Partials from "@/views/Pro/Offers/partials/form";
import { XIcon } from "vue-feather-icons";
export default {
    name: "offer-new",
    components: { FadeImage, Partials, XIcon },
    methods: {
        goToLocation($url) {
            if (this.$route.query.from) {
                this.$router.go(-1);
            } else {
                this.$router.push($url);
            }
        },
    },
};
</script>

<style lang="scss"></style>
